/**
 * /!\ Please considere local imports instead of global ones /!\
 *
 * Case where global imports are allowed :
 * - Usage of a Vue components in a backend template (PHP / XSL)
 */
import Vue from 'vue';
import SAMSubscriptionCheckout from 'vcomponents/sellsyaccountmanager/SubscriptionCheckout.vue';
import PublicCheckoutV4 from 'vcomponents/pages/account/PublicCheckout.vue';
import VueEventManager from 'vue-event-manager';

import NotFound from 'vcomponents/errors/NotFound.vue';

Vue.use(VueEventManager);

const components = {
    'sam-subscription-checkout': SAMSubscriptionCheckout,
    'sam-public-checkout-v4': PublicCheckoutV4,
    NotFound,
};

export default components;
